import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  Renderer2
} from '@angular/core';

type position = 'top-center' | 'top-left' | 'top-right';

@Directive({
  selector: '[ivLiveHint]'
})
export class HintDirective implements OnInit {

  constructor(
    private elementRef: ElementRef,
    private renderer2: Renderer2
  ) {
  }

  @Input()
  public ivLiveHint: string;

  @Input()
  public ivLiveHintPosition: position;

  private hintId = `hint-${Math.random().toString(36).substring(7)}`;

  public ngOnInit(): void {
    const hint = this.renderer2.createElement('span');
    const hintText = this.renderer2.createText(this.ivLiveHint);

    this.renderer2.addClass(this.elementRef.nativeElement, 'with-tip');
    this.renderer2.addClass(hint, 'tip');
    this.renderer2.setAttribute(hint, 'id', this.hintId);
    this.renderer2.appendChild(hint, hintText);
    this.renderer2.appendChild(this.elementRef.nativeElement, hint);

    this.setHintPosition(hint);
  }

  private setHintPosition(hintElementRef: ElementRef): void {
    const hintElementWidth: number = document.getElementById(this.hintId).clientWidth;
    const parentElementWidth: number = this.elementRef.nativeElement.clientWidth;
    const centerPos: number = (parentElementWidth - hintElementWidth) / 2;
    switch (this.ivLiveHintPosition) {
      case 'top-right':
        this.renderer2.setStyle(hintElementRef, 'left', `10px`);
        this.renderer2.setStyle(hintElementRef, 'top', `-40px`);
        break;
      case 'top-left':
        this.renderer2.setStyle(hintElementRef, 'right', `-10px`);
        this.renderer2.setStyle(hintElementRef, 'top', `-40px`);
        break;
      case 'top-center':
        this.renderer2.setStyle(hintElementRef, 'left', `${centerPos}px`);
        this.renderer2.setStyle(hintElementRef, 'top', `-40px`);
        break;
    }
  }
}
